"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var TimeOutline = function TimeOutline(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 26 26",
    width: "26",
    height: "26"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.0833333333333333,0,0,1.0833333333333333,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12C23.992,5.376,18.624,0.008,12,0z M12,22C6.477,22,2,17.523,2,12 S6.477,2,12,2s10,4.477,10,10C21.994,17.52,17.52,21.994,12,22z M17.134,15.81L12.5,11.561V6.5c0-0.552-0.448-1-1-1s-1,0.448-1,1 V12c0,0.281,0.117,0.548,0.324,0.738l4.959,4.545c0.409,0.368,1.037,0.341,1.413-0.061C17.568,16.815,17.541,16.183,17.134,15.81z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
TimeOutline.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
TimeOutline.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = TimeOutline;